import React, { Component, Fragment } from "react";
import NotificationSystem from "react-notification-system";
import {
  Container,
  Row,
  Col,
  Form,
  Label,
  Input,
  Button,
  Navbar,
} from "reactstrap";

import PageSpinner from "../components/PageSpinner";
import * as GeneralFunctions from "../GeneralFunctions";
import "../styles/login.css";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import * as Server from "../Server";
import bn from "../utils/bemnames";

const bem = bn.create("header");

const labels = {
  ActivateMerchantButton: 'Activate Merchant Button',
  mallActivate: 'Mall Activate',
  topUpActivate: 'Top-Up Activate',
  ActivateProSellerMerchantButton: 'Activate ProSeller Merchant Button',
  ActivateBasicMerchantButton: 'Activate Basic Merchant Button',
  showWallet: 'Show Wallet',
  showMarketplace: 'Show Marketplace',
  showEpipath: 'Show Epipath',
  showChat: 'Show Chat',
  showFeeds: 'Show Feeds',
  showTV: 'Show TV',
  showNews: 'Show News',
  showStreaming: 'Show Streaming',
  showBiller: 'Show Biller',
  showP2P: 'Show P2P',
  showWalletHistory: 'Show WalletHistory',
  showCashWithdrawl: 'Show CashWithdrawl',
  useWalletPayment: 'Mall - Use Wallet Payment',
  useCreditCardPayment: 'Mall - Use CreditCard Payment',
  useInstallmetPayment: 'Mall - Use Installmet Payment',
  useInternetBankingPayment: 'Mall - Use InternetBanking Payment',
  useTransferBankingPayment: 'Mall - Use TransferBanking Payment',
  useE_WalletPayment: 'Mall - Use E-Wallet Payment',
  // transferBankingList: 'Mall - Transfer BankingList',
  minimart_useWalletPayment: 'Minimart - UseWallet Payment',
  minimart_useCreditCardPayment: 'Minimart - Use CreditCard Payment',
  minimart_useInstallmetPayment: 'Minimart - Use Installmet Payment',
  minimart_useInternetBankingPayment: 'Minimart - Use InternetBanking Payment',
  minimart_useTransferBankingPayment: 'Minimart - Use TransferBanking Payment',
  minimart_useE_WalletPayment: 'Minimart - Use E-Wallet Payment',
  // minimart_transferBankingList: 'Minimart - Transfer BankingList',
};

class HideAndShowConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      appName: "",
      ActivateMerchantButton: false,
      mallActivate: false,
      topUpActivate: false,
      ActivateProSellerMerchantButton: false,
      ActivateBasicMerchantButton: false,
      showWallet: false,
      showMarketplace: false,
      showEpipath: false,
      showChat: false,
      showFeeds: false,
      showTV: false,
      showNews: false,
      showStreaming: false,
      showBiller: false,
      showP2P: false,
      showWalletHistory: false,
      showCashWithdrawl: false,
      useWalletPayment: false,
      useCreditCardPayment: false,
      useInstallmetPayment: false,
      useInternetBankingPayment: false,
      useTransferBankingPayment: false,
      useE_WalletPayment: false,
      transferBankingList: [],
      minimart_useWalletPayment: false,
      minimart_useCreditCardPayment: false,
      minimart_useInstallmetPayment: false,
      minimart_useInternetBankingPayment: false,
      minimart_useTransferBankingPayment: false,
      minimart_useE_WalletPayment: false,
      minimart_transferBankingList: []
    };
    this.onSubmit = this.onSubmit.bind(this);
  }


  componentDidMount() {
    let params = GeneralFunctions.getQueryStringParams(
      this.props.location.search
    );
    this.getConfig(params.appName);
  }

  getConfig = async (appName) => {
    try {
      if (!appName) throw Error('Appname is required');
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: `admin/hideAndShowKeys?appName=${appName}`,
        method: "GET",
      });
      if (response.success) {
        this.setState({
          showLoader: false,
          appName,
          ...response.keys
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      let response = await Server.serverRequest({
        url: `admin/update/hideAndShowKeys`,
        method: "POST",
        data: this.state
      });
      if (response.success) {
        this.setState({
          showLoader: false
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  render() {
    return (
      <Fragment>
        <Navbar
          light
          expand
          className={bem.b("#17517B")}
          style={{
            backgroundColor: "#17517B",
            borderBottom: 0,
            marginBottom: 0,
          }}
        >
          <div
            style={{
              color: "white",
              margin: "auto",
            }}
          >
            <h1
              style={{
                margin: "auto",
                fontWeight: "bold",
              }}
            >
              App Configuration
            </h1>
          </div>
        </Navbar>
        <Container>
          <PageSpinner showLoader={this.state.showLoader} />
          <div
            className="login-form"
            style={{
              margin: "20px 0px",
              maxWidth: "unset",
            }}
          >
            <Form className="form" onSubmit={this.onSubmit}>
              <Col
                style={{
                  borderBottom: "3px solid #e4e5e6",
                  marginBottom: "10px",
                }}
              >
                <h2>Settings</h2>
              </Col>
              <Row >
                {Object.keys(labels).map((label, index) =>
                  <Col key={index} sm="12" md="6" className="mt-3">
                    <Label>{labels[label]}</Label>
                    <Input
                      type="select"
                      name={label}
                      value={this.state[label]}
                      onChange={(event) =>
                        this.setState({
                          [label]: event.target.value === 'true' ? true : false
                        })
                      }
                    >
                      <option value="default" disabled>
                        Select the value
                      </option>
                      <option value={true}>
                        True
                      </option>
                      <option value={false}>
                        False
                      </option>
                    </Input>
                  </Col>
                )}
              </Row>
              <Col
                style={{
                  marginTop: "15px",
                  padding: "5px 0px",
                  borderTop: "3px solid #e4e5e6",
                }}
              ></Col>
              <Col
                style={{
                  textAlign: "center",
                }}
              >
                <Button
                  type="submit"
                  onClick={() =>
                    this.setState({
                      submitType: "submit",
                    })
                  }
                >
                  Submit
                </Button>
              </Col>
            </Form>
          </div>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Container>
      </Fragment>
    );
  }
}

export default HideAndShowConfig;
